/* @generated */

// src/assets/ui-icon/line/celebrate.tsx
import * as React from "react";
var CelebrateLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M9.682 2.603c.162-.059.334-.082.505-.069a1.186 1.186 0 0 1 1.277 1.277 1.185 1.185 0 0 1-1.277 1.277A1.186 1.186 0 0 1 8.91 3.811a1.186 1.186 0 0 1 .772-1.208Zm9.128 4.03c-.381.141-.803.145-1.245.03-.23-.06-.375-.05-.46-.031a.39.39 0 0 0-.19.104c-.12.117-.206.325-.237.524l-1.482-.232c.059-.373.232-.939.673-1.367.491-.477 1.202-.678 2.075-.45.208.054.308.03.345.015a.289.289 0 0 0 .134-.116c.124-.176.192-.466.22-.715l1.49.164c-.033.306-.132.916-.484 1.415a1.782 1.782 0 0 1-.839.659Zm-12.918.26c.042.47.178.885.433 1.212.262.336.605.52.95.598.64.145 1.282-.07 1.653-.259l-.682-1.336a1.432 1.432 0 0 1-.346.121.725.725 0 0 1-.294.01.145.145 0 0 1-.099-.058c-.03-.038-.097-.151-.121-.423-.044-.48-.188-.898-.453-1.227a1.736 1.736 0 0 0-.961-.6c-.646-.156-1.307.031-1.698.208l.62 1.367c.238-.108.537-.163.728-.117a.24.24 0 0 1 .143.083c.035.042.103.156.127.42Zm5.756 9.327c0 .41.334.744.744.744h.064c.41 0 .744-.334.744-.745h1.5a2.244 2.244 0 0 1-2.244 2.244h-.064a2.244 2.244 0 0 1-2.244-2.244h1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.53 14.596h-.003l-5.097-9.19-5.11 9.19a8.395 8.395 0 0 0-.146 1.623c0 3.533 1.717 5.25 5.25 5.25s5.25-1.717 5.25-5.25a8.4 8.4 0 0 0-.145-1.623Zm-8.674.004h7.136c.115.432.182.964.182 1.62 0 1.545-.376 2.404-.86 2.889-.486.485-1.344.86-2.89.86s-2.404-.375-2.889-.86c-.485-.486-.86-1.344-.86-2.89 0-.655.067-1.187.181-1.619Zm1.938-1.5H9.87l1.298-2.335a.75.75 0 0 0 .729-1.311l.533-.959 1.265 2.282a.75.75 0 1 0 .727 1.31l.561 1.013h-2.719a.75.75 0 1 0-1.47 0Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CelebrateLine
};
